const EMPTY_CARD_IMAGES = {
  frontFile: null,
  backFile: null,
  frontPreview: null,
  backPreview: null,
};

let cardImages = { ...EMPTY_CARD_IMAGES };

const revokePreview = (previewUrl) => {
  if (!previewUrl || typeof previewUrl !== "string") {
    return;
  }
  if (!previewUrl.startsWith("blob:")) {
    return;
  }
  try {
    URL.revokeObjectURL(previewUrl);
  } catch {
    // Ignore revoke failures for stale blob URLs.
  }
};

export const getInsuranceCardImages = () => ({ ...cardImages });

export const setInsuranceCardImages = (next = {}) => {
  cardImages = {
    frontFile: next.frontFile ?? null,
    backFile: next.backFile ?? null,
    frontPreview: next.frontPreview ?? null,
    backPreview: next.backPreview ?? null,
  };
};

export const hydrateInsuranceCardImagePreviews = () => {
  const next = { ...cardImages };

  if (next.frontFile instanceof File) {
    revokePreview(next.frontPreview);
    next.frontPreview = URL.createObjectURL(next.frontFile);
  } else {
    next.frontFile = null;
    next.frontPreview = null;
  }

  if (next.backFile instanceof File) {
    revokePreview(next.backPreview);
    next.backPreview = URL.createObjectURL(next.backFile);
  } else {
    next.backFile = null;
    next.backPreview = null;
  }

  cardImages = next;
  return { ...cardImages };
};

export const hasRequiredInsuranceCardImages = (images = cardImages) =>
  Boolean(images?.frontFile instanceof File && images?.backFile instanceof File);

export const clearInsuranceCardImages = () => {
  revokePreview(cardImages.frontPreview);
  revokePreview(cardImages.backPreview);
  cardImages = { ...EMPTY_CARD_IMAGES };
};
